import React from 'react'
import { NoResultsProps } from './../../types'

export const NoResults: React.FC<NoResultsProps> = props => props.msg?.length ? <p className={props.className ?? ''}>{props.msg}</p> : <></>
